<!--
  ~ Copyright (c) 1999 - 2019 Accorto, Inc. - All rights reserved.
  -->

<header class="slds-page-header">
  <div class="slds-page-header__row">
    <div class="slds-page-header__col-title">
      <div class="slds-media">

        <div class="slds-media__figure">
          <span *ngIf="ui.iconHref?.includes('#')"
                [ngClass]="ui.iconClass"
                class="slds-icon_container">
            <svg aria-hidden="true" class="slds-icon slds-page-header__icon">
              <use [attr.xlink:href]="ui.iconHref"/>
            </svg>
          </span>
          <span *ngIf="ui.iconHref?.endsWith('.svg')"
                class="slds-avatar slds-avatar_medium">
            <img [alt]="ui.label" [src]="ui.iconHref"/>
          </span>
        </div>

        <div class="slds-media__body">
          <div class="slds-page-header__name">
            <div class="slds-page-header__name-title">
              <h1>
                <span>{{ui?.labelPlural}}</span>
                <span [title]="filterName"
                      class="slds-page-header__title slds-truncate">{{filterName}}</span>
              </h1>
            </div>
            <div class="slds-page-header__name-switcher">
              <div class="slds-dropdown-trigger slds-dropdown-trigger_click">
                <button (click)="onClickFilterSelect()"
                        aria-haspopup="true" class="slds-button slds-button_icon slds-button_icon-small"
                        title="Switch list view">
                  <svg aria-hidden="true" class="slds-button__icon slds-icon_x-small">
                    <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#down"/>
                  </svg>
                  <span class="slds-assistive-text">Switch list view</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="slds-page-header__col-actions">
      <div class="slds-page-header__controls">
        <div class="slds-page-header__control">
          <ul class="slds-button-group-list">
            <li>
              <button (click)="onActionNew()"
                      class="slds-button slds-button_neutral"
                      title="New Record">New
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div class="slds-page-header__row">
    <div class="slds-page-header__col-meta">
      <acc-status-line [error]="error" [message]="message"
                       class="slds-page-header__meta-text"></acc-status-line>
    </div>
    <div class="slds-page-header__col-controls">
      <div class="slds-page-header__controls">
        <div class="slds-page-header__control">
          <button (click)="onClickRequery()"
                  class="slds-button slds-button_icon slds-button_icon-border-filled"
                  title="Refresh List">
            <svg aria-hidden="true" class="slds-button__icon">
              <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#refresh"/>
            </svg>
            <span class="slds-assistive-text">Refresh List</span>
          </button>
        </div>
        <div class="slds-page-header__control">
          <ul class="slds-button-group-list">
            <li>
              <button (click)="onClickFilterEdit()"
                      class="slds-button slds-button_icon slds-button_icon-border-filled" title="Filters">
                <svg aria-hidden="true" class="slds-button__icon">
                  <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#filterList"/>
                </svg>
                <span class="slds-assistive-text">Filters</span>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</header>

<section class="slds-is-relative">
  <acc-data-table [records]="records"
                  [ui]="ui"></acc-data-table>

  <acc-spinner *ngIf="busy"></acc-spinner>
</section>

